import axios from "axios"
import { BASE_URL, MEDAL_URL } from "../util/constants"
import Medal from "../interfaces/medal";

const useApiMedal = () => {
    const axiosInstance = axios.create({
        baseURL: BASE_URL
    });

    const listMedals = () => {
        return axiosInstance
            .get<Medal[]>(MEDAL_URL)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    };

    const handleError = (err: any) => {
        console.log("Error occurred: ", err);

        if (err.response) {
        console.log("Requisition returned with error:");
        console.log("Response: ", err.response.data);
        console.log("Status: ", err.response.status);
        } else if (err.request && err.config) {
        console.log("Requisition was done but didn't had server answer:");
        console.log("URL: ", err.config.baseURL);
        console.log("Method: ", err.config.method);
        console.log("URL requested: ", err.config.url);
        } else {
        console.log("Error message: ", err.message);
        }
    };

    return { listMedals };
}

export default useApiMedal;